import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

/** Editorial back control. Returns to the previous page, or home on a cold entry. */
export const BackButton = () => {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();

  if (pathname === "/" || pathname.startsWith("/admin")) return null;

  const goBack = () => {
    if (key !== "default" && window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <div
      className="fixed left-0 right-0 top-[56px] z-30 border-b border-zinc-900 bg-black md:top-[64px]"
      data-testid="back-bar"
    >
      <div className="mx-auto flex max-w-[1500px] items-center px-5 py-2.5 md:px-10">
        <button
          onClick={goBack}
          data-testid="back-button"
          className="group inline-flex items-center gap-2 text-[0.6rem] font-bold uppercase tracking-[0.2em] text-zinc-500 transition-colors hover:text-ochre"
        >
          <ArrowLeft size={13} className="transition-transform group-hover:-translate-x-1" />
          Back
        </button>
      </div>
    </div>
  );
};
